import DailyEntry from './DailyEntry'

export default DailyEntry
